import React, { useContext, useEffect } from 'react';
import { navigate } from '@reach/router';
import { ClearIcon } from 'react-magma-icons';
import { Button, ButtonColor, ButtonVariant, TabsAlignment } from 'react-magma-dom';
import { Navbar } from '../Navbar';
import { ACCESS_CODE, MAIN_NAV_LIST } from '../../constants';
import {
  StyledAccountBlock,
  StyledAccountBlockText,
  StyledBottomMenu,
  StyledBottomMenuButtons,
  StyledCrossSideButton,
  StyledSideNavigation,
  StyledSideNavigationWrapper,
} from '../Styled';
import { StyledLink } from '../Styled/StyledDropDownMenu';
import { AccountButton } from '../Button';
import { authAPI } from '../../API/auth';
import { EditToolContext } from '../../contexts/editToolContext';

interface ISideNavigation {
  current: string;
  handleOutsideClick: () => void;
}

export const SideNavigation: React.FC<ISideNavigation> = (props): JSX.Element => {
  const { current, handleOutsideClick } = props;

  const { handleLeavePage } = useContext(EditToolContext);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleWhiteSpaceClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    (event.target as HTMLLinkElement).href && handleOutsideClick();
  };

  const handleLogout = () => {
    if (!handleLeavePage(authAPI.logout, false)) {
      authAPI.logout();
    }
  };

  const renderBottomMenu = () => (
    <StyledBottomMenu>
      <StyledAccountBlock>
        <AccountButton />
        <StyledAccountBlockText>
          Logged in as:
          <br />
          <span id="inspectletIgnore"> {localStorage.getItem('email')}</span>
        </StyledAccountBlockText>
      </StyledAccountBlock>
      <StyledBottomMenuButtons>
        <StyledLink onClick={e => handleLeavePage(() => navigate(`/${ACCESS_CODE}`), false, e)} to={ACCESS_CODE}>
          <Button variant={ButtonVariant.solid} color={ButtonColor.primary}>
            Enter Access code
          </Button>
        </StyledLink>
        <Button variant={ButtonVariant.solid} color={ButtonColor.primary} onClick={handleLogout}>
          Logout
        </Button>
      </StyledBottomMenuButtons>
    </StyledBottomMenu>
  );

  return (
    <StyledSideNavigationWrapper onClick={handleOutsideClick}>
      <StyledCrossSideButton
        testId="side-nav-btn"
        variant={ButtonVariant.link}
        icon={<ClearIcon />}
        aria-label="Close side menu"
        onClick={handleOutsideClick}
      />
      <StyledSideNavigation onClick={handleWhiteSpaceClick}>
        <StyledSideNavigation>
          <Navbar
            isVertical={true}
            isSideNav={true}
            current={current}
            navLinks={MAIN_NAV_LIST}
            ariaLabel="main navigation"
            tabsAlignment={TabsAlignment.center}
          />
          {renderBottomMenu()}
        </StyledSideNavigation>
      </StyledSideNavigation>
    </StyledSideNavigationWrapper>
  );
};
